module.exports = __webpack_public_path__ + "img/SCAPIN-Logo.bbdea2d0.svg";